export default "__VITE_ASSET__BL81BgsK__"